import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { Heading } from '@restworld/ui-ds-base';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import { JobDescriptionProps } from './job-description-block.mocks';
import { LongParagraph } from '@restworld/ui-components';

import { cn } from '@restworld/utils-common';
export const DescriptionBlock = ({ subTitle, jobContractDesc }: JobDescriptionProps) => {
  const { t } = useTranslation('common');
  return (
    <DescriptionWrapper>
      <span className="flex items-center gap-1">
        <BookOpenIcon className="h-6 w-6" />
        <Heading size={4} weight="semibold">
          {t('description')}
        </Heading>
      </span>
      <LongParagraph
        subTitle={subTitle}
        content={jobContractDesc}
        isHtml
        maxLength={450}
        title={t('description')}
        headerIcon="BookOpenIcon"
        btnTitle={t('keep_on_reading')}
        noSlice
      />
    </DescriptionWrapper>
  );
};

export default DescriptionBlock;
// --> styled components
const DescriptionWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('bg-primary-50 flex flex-col p-8 gap-4 rounded-2xl w-full items-start', className)} {...props} />
);
